import { Flex, Text } from 'theme-ui'
import Svg from './SVG'
import AuthorIcon from 'images/author.svg'
import { ReactElement } from 'react'

export default function AuthorAndPublishedDate({
  author,
  publishedAt,
}: {
  author?: string
  publishedAt?: Date
}): ReactElement {
  //author comes as "undefined undefined" when it's not set
  return (
    <Flex sx={{ alignItems: 'center', gap: '0.8rem' }}>
      {author && author.indexOf('undefined') === -1 && (
        <>
          <Svg svg={AuthorIcon} width={18} height={18} />
          <Text variant="paragraphSmallBold">{author}</Text>
        </>
      )}
      {publishedAt && (
        <Text variant="paragraphSmallRegular">
          {publishedAt.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })}
        </Text>
      )}
    </Flex>
  )
}
